// Device-type codes with a matching <CODE>.svg file bundled under assets/icons/appliance/. Icons
// are resolved via a MatIconRegistry svg-icon-resolver pointing at a static, build-bundled path —
// not something Sitefinity can serve — so there's no way to know at runtime whether a given
// code's file actually exists. This set is the guard against requesting (and 404ing on) a code
// with no bundled icon file: unrecognized codes fall back to the generic SMAP icon instead.
// Add a code here only once its file actually exists in assets/icons/appliance/.
//
// Covers both major appliances and the newer LPP non-appliance product types (tools, electronics,
// etc.) — they all live under the one appliance/ folder today. The folder is still named
// "appliance" for historical reasons; renaming it is a separate, deliberately deferred change
// (touches several unrelated modules — see plan-coverage-single-cert-policy session notes).
export const KNOWN_DEVICE_ICON_CODES = new Set<string>([
  'AIRCON', 'BICM', 'COOK', 'DISH', 'DRYE', 'DRYR', 'DUCWOR', 'ELEC',
  'FREZ', 'GARBDIS', 'HEAT', 'HSTY', 'HTBSPA', 'HVAC', 'MICR', 'MICWAV',
  'ORMW', 'PLBMG', 'POOL', 'RAHD', 'RANG', 'REKEY', 'REFR', 'ROOF',
  'SEPSEW', 'SLTPL', 'SMAP', 'SREF', 'TRCP', 'WADR', 'WAOV', 'WASH',
  'WDIS', 'WELP', 'WFWS', 'WOVN', 'WSHR',
  'ACCSRY', 'AIRQ', 'ARUG', 'AUDIO', 'BATH', 'DOOR', 'DRILL', 'FACSHW',
  'FAN', 'FTNS', 'GAME', 'GRILL', 'HOMDEC', 'INDFR', 'LAWN', 'LGHT',
  'MATT', 'MINIEBK', 'MOWR', 'OUTFR', 'PAINT', 'PCARE', 'PETS', 'PWRTL',
  'SAWW', 'SMKAP', 'SMLAP', 'SMRTHM', 'SOLBAT', 'SPRTREC', 'TUBS', 'TV',
  'UNKN', 'UTV', 'VCUM', 'WBCLR', 'WELD', 'WIND',
  'AUTO', 'BEDRM', 'BLWR', 'CELFAN', 'DORBEL', 'ELECN', 'GADROPN', 'GNRLMD',
  'GNRTR', 'OPWREQ', 'PUMP', 'SMAR', 'SMPH', 'TABL', 'THROW', 'TRIMR',
  'WATHET', 'GRNDR',
]);
